<td class="td-name" text-left>
  <div class="title-status">
    <div layout-horizontal layout-align-items-center text-weight-semi-bold>
      <rt-icon [name]="icon" margin-right-small></rt-icon>
      <div>
        {{ title }}
        <rt-badge
          *ngIf="isNew"
          color="primary-gradient"
          [text]="'app.common.new' | translate"
          margin-left-small-x
        ></rt-badge>
        <span *ngIf="notifyInfo" class="notify-info">{{
          'app.subscriptions.notify_every_morning' | translate
        }}</span>
      </div>
    </div>
  </div>
</td>

<td
  rt-activity-subscriptions-table-item
  *ngFor="let type of types; trackBy: trackByType"
  [type]="$any(type)"
  [eventsGroup]="eventsGroup"
  [activitySubscriptions]="activitySubscriptions"
  (changeEvents)="changeEvents.emit($event)"
></td>
